import { GridRequest } from "projects/app-core/src/models/gridRequest";

export interface EventsFeedbackGridRequest
  extends GridRequest<EventsFeedbackSort, EventsFeedbackFilter,EventsFeedbackSearch,EventsFeedbackDateFilter> {
}

export enum EventsFeedbackSort {
  RATING = "RATING",
}
export enum EventsFeedbackSearch {
  NAME = "NAME",
}

export enum EventsFeedbackDateFilter {
  CREATED_AT = "CREATED_AT",
}

export enum EventsFeedbackFilter {
  EVENT_ID = "EVENT_ID",
  TEST = "TEST"
}
